import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useGoogleReviews } from '../../ganchos/usarResenasGoogle';
import { TestimonioTarjeta } from './TestimonioTarjeta';
import styles from './Testimonios.module.css';

// Variable de entorno para habilitar conexión real
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '';

export const TestimoniosCarrusel = () => {
  const { reviews, loading } = useGoogleReviews(GOOGLE_API_KEY);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  }, [reviews.length]);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  }, [reviews.length]);

  useEffect(() => {
    if (loading || reviews.length === 0 || isHovered) return;

    const timer = setInterval(() => {
      handleNext();
    }, 5000);

    return () => clearInterval(timer);
  }, [currentIndex, isHovered, loading, reviews.length, handleNext]);

  if (loading) {
    return <div className={styles.loading}>Cargando opiniones de Google...</div>;
  }

  if (reviews.length === 0) {
    return null;
  }

  // Generamos el array de 3 elementos rotativos para el layout
  const visibleCards = [];
  const itemsToShow = Math.min(3, reviews.length); // Mostramos hasta 3 si hay

  for (let i = 0; i < itemsToShow; i++) {
    const index = (currentIndex + i) % reviews.length;
    visibleCards.push(reviews[index]);
  }

  return (
    <div className={styles.carruselWrapper}>
      <div className={styles.encabezadoContenedor}>
        <h2 className={styles.tituloTestimonios}>
          OPINIONES <span className={styles.acento}>DE CLIENTES</span>
        </h2>
        <div className={styles.lineaSubtitulo}></div>
      </div>

      <div 
        className={styles.carruselContenedor}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <button onClick={handlePrev} className={`${styles.navBtn} ${styles.prevBtn}`} aria-label="Anterior">
          <ChevronLeft size={24} />
        </button>

        <div className={styles.tarjetasGrid}>
          {visibleCards.map((r, i) => (
            <div key={`${r.id}-${currentIndex}-${i}`} className={styles.slideAnim}>
              <TestimonioTarjeta {...r} />
            </div>
          ))}
        </div>

        <button onClick={handleNext} className={`${styles.navBtn} ${styles.nextBtn}`} aria-label="Siguiente">
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};
